<div class="register-card">
  <div class="register-content">
    <h2 class="primary-brand-color text-header mb-2">
      {{
        'admin.register.registerHeaderMessage1'
          | translate: { tenantName: this.tenantName }
      }}
      <span class="text-turquoise">{{
        'admin.register.registerHeaderMessage2' | translate
      }}</span>
    </h2>
    <ng-container *ngIf="socialLoginEnabled">
      <h3 class="primary-brand-color">Register with Social Media</h3>
      <p class="mb-3">
        One-click access! Use your existing Google, Facebook, or Apple account
        to get started instantly.
      </p>
      <iframe
        *ngIf="!isMobile()"
        id="user-login"
        [src]="userLoginSrc"
        class="login-iframe"
        [class.invite]="registerOption === 'invite'"
        frameBorder="0"
        scrolling="no"
      ></iframe>
      <app-user-login
        *ngIf="isMobile()"
        class="user-login w-100"
        authType="custLogin"
        (submitEvent)="registerSocialSignIn($event)"
      ></app-user-login>
      <div>
        <div class="or-separator">
          <span>OR</span>
        </div>
      </div>
    </ng-container>

    <form [formGroup]="registerForm">
      <div
        class="row mb-1"
        [ngClass]="{ 'mb-xs-cust': !(email.touched && email.errors) }"
        [ngClass]="{
          'mb-2': email.touched && email.errors && email.errors.required,
        }"
      >
        <div class="col-12">
          <h3 class="primary-brand-color">Register with Email</h3>
          <p>
            Step-by-Step Registration! Enter your email, define a password, and
            confirm your email to begin.
          </p>
          <app-mat-input
            [control]="$any(email)"
            label="admin.global.email"
            inputId="register-email-field"
            autocomplete="email"
            fieldClass="full-width"
            hint="admin.register.emailInfo"
            errorSuffix="."
            [errors]="{
              required: 'admin.global.field.required',
              email: 'admin.user.details.emailErrorMsgInvaild',
            }"
          ></app-mat-input>
        </div>
      </div>
      <div
        class="row mb-0-cust"
        [ngClass]="{
          'mb-3':
            (password.touched && password.errors && password.errors.required) ||
            (password.touched && password.errors && password.errors.minlength),
        }"
      >
        <div
          class="col-12"
          [ngClass]="{ '': password.touched && password.errors }"
        >
          <app-mat-input
            [control]="$any(password)"
            label="admin.global.password"
            inputId="register-password-field"
            autocomplete="new-password"
            fieldClass="full-width"
            [passwordToggle]="true"
            suffixClass="pwdicon-top"
            errorSuffix="."
            [errors]="{
              required: 'admin.global.field.required',
              minlength: 'admin.global.field.minLength',
              maxlength: 'admin.global.field.maxLength',
            }"
          ></app-mat-input>
        </div>
      </div>
      <app-terms-privacy-platform
        [message]="'admin.global.byContinuingYouAgree' | translate"
      ></app-terms-privacy-platform>
      <div class="row my-1">
        <div [class.align-center]="!registration" class="col-12">
          <app-button
            type="button"
            variant="primary"
            class="w-100"
            classes="w-100 py-3"
            (click)="registerFormAction()"
            [disabled]="!languageId || languageId <= 0"
            style="font-size: 18px"
            id="register-email-submit-button"
          >
            {{ 'admin.register.continue' | translate }}
          </app-button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-label
            >{{ 'admin.register.haveAccount' | translate }}&nbsp;<app-button
              type=" button"
              variant="none"
              classes="btn-link px-0 link-btn"
              (click)="goToLogin()"
            >
              {{ 'admin.global.login' | translate }}
            </app-button>
          </mat-label>
        </div>
      </div>
    </form>
  </div>
</div>
